import React from 'react';

import { Component } from '~types/main';
import { AuthProvider } from './auth';
import { ModalProvider } from './modal';
import { ProductProvider } from './product';
import { RegisterProvider } from './register';
import { OrderProvider } from './order';
import { NotificationModalProvider } from './notificationModal';

export function ContextProvider({ children }: Component) {
  return (
    <AuthProvider>
      <OrderProvider>
        <ModalProvider>
          <ProductProvider>
            <RegisterProvider>
              <NotificationModalProvider>
                {children}
              </NotificationModalProvider>
            </RegisterProvider>
          </ProductProvider>
        </ModalProvider>
      </OrderProvider>
    </AuthProvider>
  );
}

